import { Link } from 'react-router-dom';
import { footerLinks, SITE_EMAIL, SITE_NAME } from '@/constants/site';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="px-4 py-12 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/15 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                {SITE_NAME}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              专注于影视剧剧情介绍、角色分析与行业资讯的门户平台。我们致力于为用户提供清晰、完整的影视内容，帮助每一位观众更快了解剧情发展与角色背景。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100">
                <i className="ri-mail-line"></i>
              </span>
              <span className="text-sm text-background-200">{SITE_EMAIL}</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              内容导航
            </h4>
            <ul className="mt-4 space-y-3">
              {footerLinks.browse.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="whitespace-nowrap text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              关于本站
            </h4>
            <ul className="mt-4 space-y-3">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="whitespace-nowrap text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-relaxed text-background-300">
            本站为非商业性质的影视内容介绍与资讯演示站点，所有影视资料、简介与新闻均为内容展示用途，不提供任何在线播放或下载服务。如相关内容涉及版权问题，请联系我们处理。
          </p>
          <div className="mt-4 flex flex-col gap-2 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
            <span>© {new Date().getFullYear()} {SITE_NAME}. 保留所有权利。</span>
            <span>内容仅供学习与交流参考</span>
          </div>
        </div>
      </div>
    </footer>
  );
}